const BookingsTypes = {
  BOOKINGS_LOADING: "BOOKINGS_LOADING",
  GET_BOOKINGS_SUCCESS: "GET_BOOKINGS_SUCCESS",
  GET_BOOKING_DETAILS_SUCCESS: "GET_BOOKING_DETAILS_SUCCESS",
};

export default BookingsTypes;
